import React from 'react';
import { connect } from 'react-redux';
import { fetchAppUser } from 'actions/users';
import queryString from 'query-string';

const AuthRedirectBase = props => {
  // get params
  const params = queryString.parse(props.location.search);
  // check if token exists
  if (!params || !params.token) {
    // back to login
    console.error('err: token not found');
    props.history.goBack();
  } else {
    // get token, then refresh token (to validate)
    const token = params.token;
    const appPath = params.appPath ? params.appPath : '/';

    props
      .fetchAppUser(token)
      .then(() => props.history.push(appPath))
      .catch(() => props.history.push('/'));
  }
  return <React.Fragment />;
};

const AuthRedirect = connect(
  null,
  { fetchAppUser }
)(AuthRedirectBase);

export default AuthRedirect;
